import { searchValues } from "../utils/options";
import { Input, MultiSearchForm, useDebouncedSearch } from "@";

const MultiSearch = ({ onSubmit, search, updateSearch }) => {
  useDebouncedSearch(onSubmit, search.values, searchValues);

  const handleInputChange = (field, value) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      className="multi-search-form"
      reset={() => updateSearch({ values: searchValues })}
    >
      {/* Search input for keyword */}
      <Input
        star
        label="كلمة البحث"
        value={search.values.searchKey}
        change={(e) => handleInputChange("searchKey", e.target.value)}
      />

      {/* Date range input */}
      <Input
        star
        showTimeSelect
        type="date-range"
        labelA="من تاريخ"
        labelB="الي تاريخ"
        valueB={search.values.toDate}
        valueA={search.values.fromDate}
        changeA={(e) => handleInputChange("fromDate", e)}
        changeB={(e) => handleInputChange("toDate", e)}
      />
    </MultiSearchForm>
  );
};

export default MultiSearch;
